// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041010/js/" + chunkId + "." + {"44":"372ea976","225":"f6b1b67b","481":"73b9e0e4","486":"053d3714","770":"da7c2d72"}[chunkId] + ".0.6770740439959223.chunk.js";
};